import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { GenericProdottoType, GenericSectionThemeType, MenuItemType } from '@utils/types'
import { ProdottoCard } from '@components/molecules'
import { GenericSection, GenericSlider } from '@components/organisms'
import styles from './ProdottiSection.module.sass'

interface Props {
  refId?: string
  items?: GenericProdottoType[]
  item?: MenuItemType
  theme?: GenericSectionThemeType
  className?: string
}

const ProdottiSection = (props: Props) => {
  const { refId = undefined, items = [], item = undefined, theme = 'white', className = '' } = props

  return items?.length ? (
    <GenericSection
      refId={refId}
      item={item}
      theme={theme}
      className={`${styles.root} ${className} ${styles[`root--${theme}`]}`}
    >
      <GenericSlider
        id="prodotti-section_slider"
        navigationPos="pagination"
        conf={{
          slidesPerView: 1.1,
          spaceBetween: 20,
          modules: [A11y, Navigation, Pagination],
          navigation: true,
          pagination: { clickable: true },
          breakpoints: {
            576: {
              slidesPerView: 2.2,
            },
            768: {
              slidesPerView: 3.2,
            },
            992: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        }}
        className={styles.slider}
      >
        {items.map((i, index) => (
          <SwiperSlide key={index}>
            <ProdottoCard item={i} />
          </SwiperSlide>
        ))}
      </GenericSlider>
    </GenericSection>
  ) : (
    <></>
  )
}

export default ProdottiSection
